import axios from 'axios';

import settings from '../libs/config';
import ApiError from './apiError.js';

const endpoint = settings.api_host + '/user/penalty';

export const penalizeUser = async (user_token, user_id, value) => {
	if (!user_id || !value || !user_token) {
		throw new Error("Missing params");
	}

	try {
		const response = await axios.get(endpoint, {
			params: {
				user_token,
				user_id,
				value
			}
		});

		const data = response.data;
		return data.result;
	} catch (error) {
		throw new ApiError(error);
	}
};


// WEBPACK FOOTER //
// ./src/api/penalize.js